import _nav from './_nav.json'

const lang = {
  ..._nav,
}

export default lang
